export default __webpack_public_path__ + "static/media/Figtree-Black.ba924579.ttf";